import { zip, Subject } from 'rxjs'
import Metamask from './module/metamask'
// import { abbrevAddr } from './util/string'
// import isMobile from 'is-mobile'
import Header from './module/header'

class Detail {
    private metamask: Metamask
    private header: Header
    private ghostId: number
    private claimEndDate: number

    constructor() {
        this.claimEndDate = Date.UTC(2022, 5, 10, 8, 0, 0)
        const initializer = this.initialize
        const eventArray = Array.from(document.getElementsByTagName('div'))
            .filter((elem) => elem.getAttribute('include-html'))
            .map((elem) => {
                const file = elem.getAttribute('include-html')
                const eventEmitter = new Subject()
                fetch(file)
                    .then((response) => {
                        return response.text()
                    })
                    .then((html) => {
                        elem.insertAdjacentHTML('afterend', html)
                        elem.parentElement.removeChild(elem)
                        eventEmitter.next(true)
                    })
                    .catch((err) => {
                        console.error('error in fetching html', file, err)
                    })
                return eventEmitter
            })
        zip(eventArray).subscribe(() => {
            initializer()
        })
    }

    initialize = () => {
        this.setGhostId();
        this.setGhostSpecies(this.ghostId);

        this.header = new Header(this.ghostId)
        this.metamask = this.header.metamask

        document.getElementById('tokenId').innerText = this.ghostId.toString()

        document.getElementById('contractAddress').innerText = `${process.env.CONTRACT_ADDRESS.slice(0, 6)}...${process.env.CONTRACT_ADDRESS.slice(38, 42)}`
        document.getElementById('contractAddress').href = `https://etherscan.io/address/${process.env.CONTRACT_ADDRESS}`

        document.getElementById('titleGhost').innerText = `Ghost #${("000" + this.ghostId).slice(-4)}`

        document.getElementById('helpButton').onmouseover = () => {
            document.getElementById('helpBox').classList.remove('hidden')
        }
        document.getElementById('helpButton').onmouseleave = () => {
            document.getElementById('helpBox').classList.add('hidden')
        }

        document.getElementById('openseaLink').onmouseover = () => {
            document.getElementById('hover-opensea').classList.remove('hidden')
        }
        document.getElementById('openseaLink').onmouseleave = () => {
            document.getElementById('hover-opensea').classList.add('hidden')
        }
        document.getElementById('openseaLink').onclick = () => {
            const openseaLink = `https://opensea.io/assets/0xdf3407636bbf3a015a8e48a079ef7ba49e687fd3/${this.ghostId}`
            window.open(openseaLink, '_blank').focus()
        }

        document.getElementById('shareButton').onmouseover = () => {
            document.getElementById('hover-share').classList.remove('hidden')
        }
        document.getElementById('shareButton').onmouseleave = () => {
            document.getElementById('hover-share').classList.add('hidden')
        }
        document.getElementById('shareButton').onclick = () => {
            const shareBox = document.getElementById('shareBox')
            if (shareBox.classList.contains('hidden'))
                shareBox.classList.remove('hidden')
            else
                shareBox.classList.add('hidden')
        }

        document.getElementById('twitterLink').onclick = this.shareOnTwitter
        document.getElementById('facebookLink').onclick = this.shareOnFB
        document.getElementById('telegramLink').onclick = this.shareOnTelegram

        document.getElementById('copyLink').onclick = () => {
            navigator.clipboard.writeText(window.location.toString()).then(() => window.alert('Sharing URL is copied.'))
        }

        this.waitUntilMetamaskReady()
    }

    setGhostId = () => {
        const searchParams = new URLSearchParams(window.location.search)
        const ghostIdRaw = searchParams.get('id')
        if (ghostIdRaw === null || parseInt(ghostIdRaw) > 9999 || parseInt(ghostIdRaw) < 0) {
            this.ghostId = 0
        } else {
            this.ghostId = parseInt(ghostIdRaw)
        }
    }

    setGhostSpecies = (ghostId: number) => {
        const url = 'https://ipfs.io/ipfs/QmVtFzvoEgD92pHydcLg2AnHFH2YtUsXUh85QRH4LxzbXz'
        fetch(url).then((resp) => resp.json()).then((speciesMap) => {
            const species = speciesMap[ghostId.toString()]
            document.getElementById('species').innerText = species
            if (species === 'Skull')
                document.getElementById('species').classList.add('skull')
            else if (species === 'Male' || species === 'Female')
                document.getElementById('species').classList.add('normal')
            else
                document.getElementById('species').classList.add('infected')
        })
    }

    shareOnFB = () => {
        const url = `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`
        window.open(url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600')
    }

    shareOnTwitter = () => {
        const url = `https://twitter.com/intent/tweet?url=${window.location.href}`
        window.open(url, '','menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600')
    }

    shareOnTelegram = () => {
        const url = `https://t.me/share/url?url=${window.location.href}`
        window.open(url, '','menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600')
    }

    waitUntilMetamaskReady = () => {
        if (!this.metamask.isReady) {
            window.setTimeout(this.waitUntilMetamaskReady, 100); /* this checks the flag every 100 milliseconds*/
        } else {
            this.updateWeb3Info()
        }
    }

    updateWeb3Info = () => {
        this.getSpecialFragmentStatus()
        this.getMemoriesText()
    }

    getSpecialFragmentStatus = async () => {
        const nowDate: number = new Date().valueOf()
        let claimable: string
        if (this.claimEndDate < nowDate) {
            claimable = "[TREASURY] Special Fragment was not claimed within the claim period, May 20th, 3 PM - June 10th, 8 AM UTC. Special Fragment that is not claimed was sent to the GhostsProject treasury."
        } else {
            claimable = "[CLAIMABLE] Special Fragment is claimable. Special Fragment must be claimed within the claim period, May 20th, 3 PM - June 10th, 8 AM UTC."
        }
        const elm = document.getElementById('specialFragment')
        this.metamask.isVerified(this.ghostId).then((isVerified: boolean) => {
            if (!isVerified)
                elm.innerText = "[INELIGIBLE] This Ghost did not select Memories during the selection period, May 20th, 3 PM - June 10th, 8 AM UTC."
            else {
                this.metamask.isClaimed(this.ghostId).then((isClaimed: boolean) => {
                    if (isClaimed)
                        elm.innerText = "[CLAIMED] Special Fragment is claimed. The claim period was May 20th, 3 PM - June 10th, 8 AM UTC."
                    else
                        elm.innerText = claimable
                })
            }
        })
    }

    getMemoriesText = async () => {
        this.metamask.getMemories(this.ghostId).then(async (memories: string) => {
            if (memories !== "") {
                const isValid = await this.metamask.hasCorrectMemory(this.ghostId)
                if (!isValid)
                    return

                document.getElementById('memories').classList.add('normalMemories')
                const memoryType = await this.metamask.getMemoryType(this.ghostId)
                let typeColor: string
                if (memoryType === "GOOD")
                    typeColor = "blue"
                else if (memoryType === "EVIL")
                    typeColor = "red"
                else
                    typeColor = ""

                let onlyMemories = ""
                let flashback = ""
                if (memories.includes("[FB]")) {
                    [onlyMemories, flashback] = memories.split("[FB]")
                    document.getElementById('memories').innerHTML = `<b class='text ${typeColor}'>[${memoryType}]</b><b class='text'>${onlyMemories}</b>`
                    document.getElementById('flashback').innerHTML = `<b class='text'>${flashback}</b>`
                    document.getElementById('flashback-div').classList.remove('hidden')
                } else {
                    document.getElementById('memories').innerHTML = `<b class='text ${typeColor}'>[${memoryType}]</b><b class='text'>${memories}</b>`
                }
            } else {
                document.getElementById('memories').innerHTML = '<div class="missing">Memory is not selected yet. Check the</div>'
                document.getElementById('memories').innerHTML += '<a class="linkText" href="/memories.html">MEMORIES page</a>'
            }
        })
    }
}
//experience
//memories

new Detail()
